import React from "react";

import { clx } from "../../../utils/Helpers";

export const fromLegacyEmptyStateProps = ({
  subTitle,
  description,
  buttonLabel,
  handleCreate,
  showActionButton = true,
  imgSrc,
  containerClasses,
  actionBtnDisabled,
  imgClass,
}) => {
  const title = subTitle || description;
  const resolvedDescription = subTitle ? description : null;
  const illustration = imgSrc ? (
    <img
      src={imgSrc}
      alt=""
      className={clx("img-fluid px-4", imgClass)}
    />
  ) : null;

  return {
    title,
    description: resolvedDescription,
    illustration,
    actionLabel: showActionButton ? buttonLabel : null,
    onAction: showActionButton && handleCreate ? handleCreate : undefined,
    actionButtonProps: actionBtnDisabled ? { disabled: true } : undefined,
    classNames: containerClasses ? { root: containerClasses } : {},
  };
};
